import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { MainCampaignActions } from '../../main-campaign.actions';
import { mainCampaignServices } from '../../main-campaign.services';
import { GlobalService } from '../../../global.service';
import { Router } from '@angular/router';

import { from } from 'rxjs';
import { pluck } from 'rxjs/operators';

@Component({
    selector: 'app-new-line-step-3',
    templateUrl: './new-line-step-3.component.html',
    styleUrls: ['./new-line-step-3.component.scss']
})
export class NewLineStep3Component implements OnInit {

    step3: any;
    subscription: any;
    form: FormGroup;
    listCountries: any;
    listCountriesNew: any;
    billingAddressStateList: any;
    delivaryAddressStateList: any;
    companyName: any;
    companyCountry: any;
    companyCity: any;
    companyPostCode: any;
    companyState: any;
    companyStreetName: any;
    initialData: any = null;
    tab: any;
    skipData: any = {
        step1: {},
        step2: {}
    };

    uploadScannedIC: { [key: string]: any } = {
        name: '',
        src: '',
        file: '',
    };

    uploadBackScannedIC: { [key: string]: any } = {
        name: '',
        src: '',
        file: '',
    };

    uploadStaffID: { [key: string]: any } = {
        name: '',
        src: '',
        file: '',
    };
    goToStep3: any;
    disabledBack = false;
    displayUploadImgStaffID: boolean = true;
    disableDeliveryAddressSection :boolean = true;

    show_popup:boolean = false;
	popup_image:any;
	url_popup:any;


    constructor(private store: Store<any>,
        private mainCampaignActions: MainCampaignActions,
        private fb: FormBuilder,
        private router: Router,
        private mainCampaignServices: mainCampaignServices,
        private globalService: GlobalService) {

        const source = from(store);
        const example = source.pipe(pluck('mainCampaign', 'step3'));
        this.subscription = example.subscribe((res: { [key: string]: any }) => {
            // this.subscription = store.select("mainCampaign").select("step3").subscribe(res => {
            if (res) {
                this.uploadScannedIC = Object.assign({}, res.uploadScannedIC);
                this.uploadBackScannedIC = Object.assign({}, res.uploadBackScannedIC);
                this.uploadStaffID = Object.assign({}, res.uploadStaffID);
                this.tab = res.tab;
            }
        });

        store.subscribe((res: { [key: string]: any }) => {
            this.skipData.step1 = res.mainCampaign.step1;
            this.skipData.step2 = res.mainCampaign.step2;
        });

        // store.select("mainCampaign").select("step3").subscribe(store => {
        this.subscription = example.subscribe((res: { [key: string]: any }) => {
            if (res.tab != this.tab) {
                this.tab = res.tab;
            }
        });
        if (!this.globalService.getSession('mainApplication').planId) {
            this.disabledBack = true;
        }

        // get session

        this.step3 = this.globalService.getSession('mainApplication').step2;

        if (this.globalService.getSession('mainApplication').step3) {
            this.initialData = this.globalService.getSession('mainApplication').step3;
            this.companyName = this.initialData.yourDetail.companyName;
            this.companyCountry = this.initialData.yourDetail.companyCountry;
            this.companyCity = this.initialData.yourDetail.companyCity;
            this.companyPostCode = this.initialData.yourDetail.companyPostCode;
            this.companyState = this.initialData.yourDetail.companyState;
            this.companyStreetName = this.initialData.yourDetail.companyStreetName;
        } else {
            if (this.globalService.getSession('viewPlan').attributes) {
                this.companyName = this.globalService.getSession('viewPlan').attributes.company_name;
                this.companyCountry = this.globalService.getSession('viewPlan').attributes.company_country;
                this.companyCity = this.globalService.getSession('viewPlan').attributes.company_city;
                this.companyPostCode = this.globalService.getSession('viewPlan').attributes.company_postcode;
                this.companyState = this.globalService.getSession('viewPlan').attributes.company_state;
                this.companyStreetName = this.globalService.getSession('viewPlan').attributes.company_streetname;
            }
        }

        // init form
        this.form = fb.group({
            yourDetail: fb.group({
                fullName: [(this.initialData) ? this.initialData.yourDetail.fullName : '', Validators.compose([Validators.required, this.globalService.onlyCharacter, this.globalService.characterSpecialHasSpace])],
                NRIC: [(this.initialData) ? this.initialData.yourDetail.NRIC : '', Validators.compose([Validators.required, Validators.minLength(12), Validators.maxLength(12), this.globalService.isNumber])],
                email: [(this.initialData) ? this.initialData.yourDetail.email : '', Validators.compose([Validators.required, this.globalService.emailValidator])],
                // company: [(this.initialData) ? this.initialData.yourDetail.company : '', Validators.compose([this.globalService.characterSpecialForCompay])],

                contactNumber: [(this.initialData) ? this.initialData.yourDetail.contactNumber : '', Validators.compose([Validators.required, this.globalService.isPhone])],
                //cardLastDigit:[ (this.initialData) ? this.initialData.yourDetail.cardLastDigit : "" , Validators.compose([this.globalService.isNumber , Validators.required ,Validators.maxLength(4) , Validators.minLength(4)] ) ],
                uploadScannedIC: [(this.initialData) ? this.initialData.yourDetail.uploadScannedIC : '', Validators.required],
                uploadBackScannedIC: [(this.initialData) ? this.initialData.yourDetail.uploadBackScannedIC : '', Validators.required],
                uploadScannedStaffID: [(this.initialData) ? this.initialData.yourDetail.uploadScannedStaffID : '', Validators.required],
                passportNumber: [(this.initialData) ? this.initialData.yourDetail.passportNumber : '', Validators.compose([Validators.required, this.globalService.characterSpecial])],
                issuedCountry: ['', Validators.required],
                companyName: [(this.companyName) ? this.companyName : ''],
                companyCountry: [(this.companyCountry) ? this.companyCountry : ''],
                companyCity: [(this.companyCity) ? this.companyCity : ''],
                companyPostCode: [(this.companyPostCode) ? this.companyPostCode : ''],
                companyState: [(this.companyState) ? this.companyState : ''],
                companyStreetName: [(this.companyStreetName) ? this.companyStreetName : ''],
            }),

            billingAddress: fb.group({
                sameAsBillingAddress: (this.initialData) ? this.initialData.billingAddress.sameAsBillingAddress : false,
                streetName1: [(this.initialData) ? this.initialData.billingAddress.streetName1 : '', Validators.required],
                city: [(this.initialData) ? this.initialData.billingAddress.city : '', Validators.required],
                state: ['', Validators.required],
                postCode: [(this.initialData) ? this.initialData.billingAddress.postCode : '', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5), this.globalService.isNumber])],
                country: ['', Validators.required]
            }),

            deliveryAddress: fb.group({
                streetName1: [(this.initialData) ? this.initialData.deliveryAddress.streetName1 : '', Validators.required],
                city: [(this.initialData) ? this.initialData.deliveryAddress.city : '', Validators.required],
                state: ['', Validators.required],
                postCode: [(this.initialData) ? this.initialData.deliveryAddress.postCode : '', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5), this.globalService.isNumber])],
                country: ['', Validators.required]
            }),

            referenceContactInfo: fb.group({
                fullName: [(this.initialData) ? this.initialData.referenceContactInfo.fullName : '', Validators.compose([Validators.required, this.globalService.onlyCharacter, this.globalService.characterSpecialHasSpace])],
                contactNumber: [(this.initialData) ? this.initialData.referenceContactInfo.contactNumber : '', Validators.compose([Validators.required, this.globalService.isPhone])]
            }),

            policy: fb.group({
                confirm: [(this.initialData) ? this.initialData.policy.confirm : false, Validators.pattern('true')]
            })
        });


    }

    ngOnInit() {
        if (this.globalService.getSession('viewPlan').attributes.disable_upload_img_staffid === 1){
            this.displayUploadImgStaffID = false;
            this.form.get('yourDetail.uploadScannedStaffID').clearValidators();
        }
        this.disableDeliveryAddressSection = this.globalService.getSession('viewPlan').attributes.disable_edit_delivery_address;

        this.form.get('yourDetail.email').markAsDirty();
        this.form.get('yourDetail.contactNumber').markAsDirty();

        // get list countries
        this.mainCampaignServices.getJSONCountries().subscribe(res => {
            this.listCountries = res.countries;
            if (this.initialData) {

                //issuedCountry
                this.form.get('yourDetail.issuedCountry').setValue(this.initialData.yourDetail.issuedCountry);

                // billingAddress
                let countryIndex = this.listCountries.findIndex(country => {
                    return country.country == this.initialData.billingAddress.country.country;
                });

                this.form.get('billingAddress.country').setValue(this.listCountries[countryIndex]);
                this.onChangeCountryBillingAddress();
                setTimeout(() => {
                    this.form.get('billingAddress.state').setValue(this.initialData.billingAddress.state);
                }, 0);

                // deliveryAddress
                let countryIndex1 = this.listCountries.findIndex(country => {
                    return country.country == this.initialData.deliveryAddress.country.country;
                });
                this.form.get('deliveryAddress.country').setValue(this.listCountries[countryIndex1]);
                this.onChangeCountryDeliveryAddress();
                setTimeout(() => {
                    this.form.get('deliveryAddress.state').setValue(this.initialData.deliveryAddress.state);
                    this.onChangeSameAsBillingAddress();
                }, 0);

            } else {
                // billingAddress
                let countryIndex = this.listCountries.findIndex(country => {
                    return country.country == 'Malaysia';
                });
                this.form.get('billingAddress.country').setValue(this.listCountries[countryIndex]);
                this.onChangeCountryBillingAddress();

                // deliveryAddress
                let countryIndex1 = this.listCountries.findIndex(country => {
                    return country.country === this.companyCountry;
                });
                this.form.get('deliveryAddress.country').setValue(this.listCountries[countryIndex1]);
                this.onChangeCountryDeliveryAddress();

                // set default state
                this.form.get('deliveryAddress.state').setValue(this.companyState);

                //set default company street
                this.form.get('deliveryAddress.streetName1').setValue(this.companyStreetName);

                //set default post code
                this.form.get('deliveryAddress.postCode').setValue(this.companyPostCode);

                //set default city
                this.form.get('deliveryAddress.city').setValue(this.companyCity);

            }
        });


        if (this.tab == 1) {
            /**----set validate NRIC */
            this.form.get('yourDetail.NRIC').setValidators([Validators.required, Validators.minLength(12), Validators.maxLength(12), this.globalService.isNumber]);

            /**----clear validate passport */
            this.form.get('yourDetail.passportNumber').clearValidators();
            this.form.get('yourDetail.issuedCountry').clearValidators();
            this.form.get('yourDetail.passportNumber').setValue('');
            this.form.get('yourDetail.issuedCountry').setValue('');
        } else {

            /**----clear validate passport */
            this.form.get('yourDetail.NRIC').clearValidators();
            this.form.get('yourDetail.NRIC').setValue('');

            /**----set validate NRIC */
            this.form.get('yourDetail.passportNumber').setValidators(Validators.compose([Validators.required, this.globalService.characterSpecial]));
            this.form.get('yourDetail.issuedCountry').setValidators(Validators.required);

        }


        if (!this.uploadScannedIC.src || !this.uploadBackScannedIC.src || !this.uploadStaffID.src) {
            this.form.get('yourDetail.uploadScannedIC').setValue('');
            this.form.get('yourDetail.uploadBackScannedIC').setValue('');
            this.form.get('yourDetail.uploadScannedStaffID').setValue('');
        }

        this.show_popup = this.globalService.getSession('show_popup_3rdpage') == 1;
        this.popup_image = this.show_popup ? this.globalService.getSession('popup_3rdpage') : "";
		this.url_popup = this.show_popup ? this.globalService.getSession('link_popup_3rdpage') : "#";
		console.log(this.globalService.getSession('show_popup_frontpage'));
		if(this.show_popup){
			let element:HTMLElement = document.getElementById('popup-3rdpage-btn') as HTMLElement;
			element.click();
		}
    }

    //------------------click change tab NRIC/Passport
    clickTab(number: any) {
        if (number == 1) {
            $('.tab-item').removeClass('active');
            $('.nric').addClass('active');

            /**----set validate NRIC */
            this.form.get('yourDetail.NRIC').setValidators([Validators.required, Validators.minLength(12), Validators.maxLength(12), this.globalService.isNumber]);

            /**----clear validate passport */
            this.form.get('yourDetail.passportNumber').clearValidators();
            this.form.get('yourDetail.issuedCountry').clearValidators();
            this.form.get('yourDetail.passportNumber').setValue('');
            this.form.get('yourDetail.issuedCountry').setValue('');
        } else {
            $('.tab-item').removeClass('active');
            $('.passport').addClass('active');

            /**----clear validate passport */
            this.form.get('yourDetail.NRIC').clearValidators();
            this.form.get('yourDetail.NRIC').setValue('');

            /**----set validate NRIC */
            this.form.get('yourDetail.passportNumber').setValidators(Validators.compose([Validators.required, this.globalService.characterSpecial]));
            this.form.get('yourDetail.issuedCountry').setValidators(Validators.required);
        }

        this.tab = number;

        this.form.get('yourDetail.NRIC').updateValueAndValidity();
        this.form.get('yourDetail.passportNumber').updateValueAndValidity();
        this.form.get('yourDetail.issuedCountry').updateValueAndValidity();

    }


    //----------------Change Country reload state
    onChangeCountryBillingAddress() {
        this.billingAddressStateList = this.form.get(['billingAddress', 'country']).value.states;
        this.form.get(['billingAddress', 'state']).setValue('');
    }

    onChangeCountryDeliveryAddress() {
        this.delivaryAddressStateList = this.form.get(['deliveryAddress', 'country']).value.states;
        this.form.get(['deliveryAddress', 'state']).setValue('');
    }


    // --------------ScannedIC
    onChangeUploadScannedIC($event) {
        let nameImage = $event.target.value.split('\\')[$event.target.value.split('\\').length - 1];
        this.globalService.uploadPhotos($event, (file, resizedBlog) => {
            if (file) {
                this.globalService.readURLImageFile(resizedBlog, e => {
                    this.uploadScannedIC.file = file;
                    this.uploadScannedIC.src = e;
                    this.uploadScannedIC.name = nameImage;
                    this.uploadScannedIC.error = '';
                    this.form.get('yourDetail.uploadScannedIC').setValue(nameImage);
                });
            } else {
                this.onRemoveUploadScannedIC();
                this.uploadScannedIC.error = 'Please select image <= 5MB';
            }
        });
    };

    onRemoveUploadScannedIC() {
        this.uploadScannedIC = {
            src: '',
            name: '',
            file: ''
        };
        $('#uploadScannedIC').val('');
        this.form.get('yourDetail.uploadScannedIC').setValue('');
    }

    // --------------Back ScannedIC
    onChangeUploadBackScannedIC($event) {
        let nameImage = $event.target.value.split('\\')[$event.target.value.split('\\').length - 1];
        this.globalService.uploadPhotos($event, (file, resizedBlog) => {
            if (file) {
                this.globalService.readURLImageFile(resizedBlog, e => {
                    this.uploadBackScannedIC.file = file;
                    this.uploadBackScannedIC.src = e;
                    this.uploadBackScannedIC.name = nameImage;
                    this.uploadBackScannedIC.error = '';
                    this.form.get('yourDetail.uploadBackScannedIC').setValue(nameImage);
                });
            } else {
                this.onRemoveUploadBackScannedIC();
                this.uploadBackScannedIC.error = 'Please select image <= 5MB';
            }
        });
    };

    onRemoveUploadBackScannedIC() {
        this.uploadBackScannedIC = {
            src: '',
            name: '',
            file: ''
        };
        $('#uploadBackScannedIC').val('');
        this.form.get('yourDetail.uploadBackScannedIC').setValue('');
    }

    // ---------------------StaffID
    onChangeuploadStaffID($event) {
        let nameImage = $event.target.value.split('\\')[$event.target.value.split('\\').length - 1];
        this.globalService.uploadPhotos($event, (file, resizedBlog) => {
            if (file) {
                this.globalService.readURLImageFile(resizedBlog, e => {
                    this.uploadStaffID.file = file;
                    this.uploadStaffID.src = e;
                    this.uploadStaffID.name = nameImage;
                    this.uploadStaffID.error = '';
                    this.form.get('yourDetail.uploadScannedStaffID').setValue(nameImage);
                });
            } else {
                this.onRemoveUploadStaffID();
                this.uploadStaffID.error = 'Please select image <= 5MB';
            }
        });
    };

    onRemoveUploadStaffID() {
        this.uploadStaffID = {
            src: '',
            name: '',
            file: ''
        };
        $('#uploadStaffID').val('');
        this.form.get('yourDetail.uploadScannedStaffID').setValue('');
    };

    // -------------click change same above
    onChangeSameAsBillingAddress() {
        if (this.form.get('billingAddress.sameAsBillingAddress').value) {
            this.form.get('billingAddress.streetName1').clearValidators();
            this.form.get('billingAddress.city').clearValidators();
            this.form.get('billingAddress.country').clearValidators();
            this.form.get('billingAddress.state').clearValidators();
            this.form.get('billingAddress.postCode').clearValidators();
        } else {
            this.form.get('billingAddress.streetName1').setValidators(Validators.required);
            this.form.get('billingAddress.city').setValidators(Validators.required);
            this.form.get('billingAddress.country').setValidators(Validators.required);
            this.form.get('billingAddress.state').setValidators(Validators.required);
            this.form.get('billingAddress.postCode').setValidators(Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5), this.globalService.isNumber]));
        }
        this.form.get('billingAddress.streetName1').updateValueAndValidity();
        this.form.get('billingAddress.city').updateValueAndValidity();
        this.form.get('billingAddress.country').updateValueAndValidity();
        this.form.get('billingAddress.state').updateValueAndValidity();
        this.form.get('billingAddress.postCode').updateValueAndValidity();
    }


    // --------------next
    onClickNext() {
        // set value if delivery address same as above
        if (this.form.get('billingAddress.sameAsBillingAddress').value) {
            this.form.get('billingAddress.streetName1').setValue(this.form.get('deliveryAddress.streetName1').value);
            this.form.get('billingAddress.city').setValue(this.form.get('deliveryAddress.city').value);
            this.form.get('billingAddress.country').setValue(this.form.get('deliveryAddress.country').value);
            this.onChangeCountryBillingAddress();
            this.form.get('billingAddress.state').setValue(this.form.get('deliveryAddress.state').value);
            this.form.get('billingAddress.postCode').setValue(this.form.get('deliveryAddress.postCode').value);
        }

        // save new Value form
        let newValue = Object.assign({}, this.form.getRawValue());
        let newValueSession;


        if (this.globalService.getSession('mainApplication').planId) {
            //save session
            newValueSession = {
                step3: Object.assign({}, newValue)
            };

        } else {
            //save session
            newValueSession = {
                step1: Object.assign({}, this.skipData.step1),
                step2: Object.assign({}, this.skipData.step2),
                step3: Object.assign({}, newValue),
            };
        }

        newValueSession = Object.assign({}, this.globalService.getSession('mainApplication'), newValueSession);
        this.globalService.setSession('mainApplication', newValueSession);

        // console.log(newValueSession)


        // next
        this.store.dispatch(this.mainCampaignActions.updateStep3(Object.assign({},
            {
                tab: this.tab,
                uploadScannedIC: this.uploadScannedIC,
                uploadBackScannedIC: this.uploadBackScannedIC,
                uploadStaffID: this.uploadStaffID
            })));
    }

    checkMaxLengthPostCode(event, maxlength) {
        if (event.target.value.length >= maxlength) {
            event.preventDefault();
        }
    }

    onClickPrevViewPlan() {
        this.router.navigateByUrl('/view-plans');
        this.store.dispatch(this.mainCampaignActions.goToStep3(false));

    }

    onClickPrev() {
        this.store.dispatch(this.mainCampaignActions.stepPrev());
    }


    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

}
